import React, { Component } from "react"
import { PropTypes } from "prop-types"
import { Col, FormGroup, Row, Panel, Button } from "react-bootstrap"
import  { red, green, blue } from '../../../utils/constants'
import { isEmpty } from "../../../utils/functions";

const box = { 
	textAlign: 'left',
	minWidth: '380px',
	minHeight:'400px',
    padding: '6px 0 0 8px',
    margin:'-10px 0 10px 0',
	fontSize:'13px',
	fontWeight:'bold',
}

class Transfer extends Component {
    constructor(props)
    {
        super(props)
        this.state = {
            isError:false
        }
		this.handleCancel = this.handleCancel.bind(this);
        this.handleTransfer = this.handleTransfer.bind(this);
    }

    handleCancel(){
       this.props.onCancel();
    }
	
	handleTransfer(){
        const { event } = this.props;
        const from = event.eventId;
        const to = document.getElementById("to").value;
        const amount = document.getElementById("amount").value;
        const notes = document.getElementById("notes").value;

        const transferObj = {
            from,
            to,
            amount,
            notes
        }

        if(isEmpty(amount) || amount > event.balance){
            this.setState({
                isError:true
            })
            return;
        } else {
            this.setState({
                isError:false
            })
        
            this.props.onSave(transferObj);
        }
    }

    eventOptions()
    {
        const { searchResults, event } = this.props
        const events = Object.values(searchResults)
        const option = (events.filter(e => e.eventId !== event.eventId )).map((event) => {
            return (<option key={event.eventId} value={event.eventId}>{event.name}</option>)
        })
        return option;
    }

    render(){
        const {
            saving,
            event,
            searchResults
        } = this.props;
        const { isError } = this.state;

        const hasEvents = (searchResults !== undefined) && (searchResults.length > 1);
        
        return (
            <FormGroup controlId="searchby" className="searchby-filter">
        <Row>
        <Col sm={3}  >
            <Panel  style={{ ...box }}>
                <h5 style={{ color:blue, marginTop:'-10px' }}>Transfer</h5>
                {isError && 
                    <p>
                        <span style={{ color:red }}>* Amount is required and it must be less or equal to Available balance</span>
                    </p>
                } 
                <p>Season:&nbsp;&nbsp; {event.season}</p>
                <p style={{ paddingLeft:'15px' }}>From:&nbsp;&nbsp;&nbsp; {event.name}</p>
                <p style={{ paddingLeft:'35px' }}>To:&nbsp;&nbsp;  
                    <select id="to" style={{ minWidth:'270px', minHeight:'32px', padding:'5px' }}>
                      { this.eventOptions() }
                    </select>
                </p>
                <p>Available:&nbsp;&nbsp;${event.balance}</p>
                <p>Amount:&nbsp;&nbsp;  <input type='number' id="amount" className="no-spinners" style={{ maxWidth:'80px', minHeight:'32px', padding:'5px' }} placeholder='$XX.XX'/></p>
                <p><span>Notes:</span>&nbsp;&nbsp;  <textarea id="notes" rows='3' style={{ minWidth:'270px', minHeight:'32px', padding:'5px', marginLeft:'12px' }} /></p>
                <FormGroup >
                    <Button onClick={ this.handleCancel } style={{ color: red, marginTop: '15px', marginLeft: '10px' }}>
                        <i className="fa fa-remove" aria-hidden="true"  />&nbsp;&nbsp;Cancel
                    </Button>
                    <Button onClick={ this.handleTransfer } style={{ color: green, marginTop: '15px', marginLeft:'10px' }} disabled={!hasEvents}>
                        <i className={saving ? 'fa fa-spinner fa-spin' : "fa fa-arrow-right"} aria-hidden="true"  />&nbsp;&nbsp;Make Transfer
                    </Button>                              
                </FormGroup>
            </Panel>            
        </Col>

        </Row></FormGroup>)
        }
}

Transfer.propTypes = {
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
    saving: PropTypes.bool,
    event: PropTypes.object,
    searchResults: PropTypes.array
}

export default Transfer


// WEBPACK FOOTER //
// ./src/containers/deposit/components/transfer.js